var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.object.error_data
    ? _c(
        "div",
        {
          staticClass: "k-item body denied",
          class: { selected: _vm.selected },
        },
        [
          _c("i-lock", { staticClass: "icon", attrs: { title: "Denied" } }),
          _c("span", { staticClass: "text" }, [_vm._v("Permission denied")]),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "k-item body", class: { selected: _vm.selected } },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c(
                "w-btn-icon",
                {
                  staticClass: "selector",
                  class: { selected: _vm.selected },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.select.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [_vm.selected ? _c("i-checked") : _c("i-unchecked")],
                    1
                  ),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "text",
                  attrs: {
                    to:
                      "/admin/content/" +
                      _vm.type +
                      "/" +
                      (_vm.object.slug || _vm.object.id),
                  },
                },
                [_c("span", { domProps: { innerHTML: _vm._s(_vm.title) } })]
              ),
            ],
            1
          ),
          _vm.object.collections || Object.keys(_vm.actions).length
            ? _c(
                "div",
                { staticClass: "info" },
                [
                  _vm._l(_vm.object.collections, function (collection) {
                    return _c(
                      "a",
                      {
                        staticClass: "attribute collection",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c("i-chevron-right", {
                          staticClass: "icon",
                          attrs: { decorative: "" },
                        }),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(collection.name) },
                        }),
                      ],
                      1
                    )
                  }),
                  _c(
                    "k-actions-icons",
                    _vm._b(
                      { attrs: { item: _vm.object } },
                      "k-actions-icons",
                      {
                        model: _vm.model,
                        actions: _vm.actions,
                        icons: _vm.icons,
                      },
                      false
                    )
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }